const experience = [
  {
    title: 'CEO & Co-Founder, Voxxy',
    date: '2025 to Present',
    description:
      'Leading product, fundraising, and go-to-market for a B2B SaaS platform serving recurring event producers. Shipped to GA with paying customers, co-produced live events including the Spring Fash-a-thon and Taste of Brooklyn, and preparing for a pre-seed raise.',
  },
  {
    title: 'Senior Technical Program Manager, Microsoft',
    date: '2019 to 2024',
    description:
      'Led product strategy and cross-functional delivery for enterprise tooling used by 10,000+ employees. Built dashboards, Power Apps, and Azure DevOps integrations. Hosted conferences, hackathons, and internal programs focused on engineering excellence.',
  },
  {
    title: 'Partner Development Manager, Microsoft',
    date: '2017 to 2019',
    description:
      'Managed a $2M Azure portfolio across 50+ startups and ISVs. Drove cloud adoption strategy, delivered technical training to 100+ new recruits, and represented Microsoft at industry events.',
  },
];

export default experience;
